export default __webpack_public_path__ + "static/media/merchant.b4074b72.ttf";